import {AfterViewInit, Component, Inject, Input, OnDestroy, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';

import {Dataset, Folder, FourdCesiumHelper, FourDService, Transform, TransformType} from '4d-mapper';
import {Observable, Subscription} from 'rxjs/index';
import {map} from 'rxjs/operators';
import {AppDialog} from './app-dialog';
import {APIDialog} from './explorer.dialogs';
import {Constants} from '../Constants';
import { XsApplicationEventsService } from '@src/app/xs/services/events/application-events.service';
import { XsEventListenerInterface } from '@src/app/xs/interfaces/event-listener.interface';
import { XsIdentityInterface } from '@src/app/xs/interfaces/identify.interface';
import { TranslateService } from '@ngx-translate/core';
import { Public3DRenderer } from '../../v2/commons/cesium/public-3d-renderer';
import { CesiumMapService } from '@src/app/service/map-viewer.service';

const Cesium = (<any>window).Cesium
const M = require('moment')

@Component({
  selector: 'map-dialog-plot-all',
  templateUrl: './map-dialog-plot-all.html',
})

export class MapDialogPlotAll implements AfterViewInit, OnDestroy {

  helper: FourdCesiumHelper = null;

  transform: any[];
  viewer: any
  handler: any

  obj: any

  creatingQuickView = false;

  selector;
  rectangleSelector = new Cesium.Rectangle();
  screenSpaceEventHandler;
  cartesian = new Cesium.Cartesian3();
  tempCartographic = new Cesium.Cartographic();
  center = new Cesium.Cartographic();
  firstPoint = new Cesium.Cartographic();
  firstPointSet = false;
  mouseDown = false;
  @Input()
  public myCallback: Function;
  private camera: any;
  private getSelectorLocations: any;

  private photoscanTransformType: TransformType;
  private selectedFolder: Folder;
  private scene: any;
  private camera_height = 50;
  private ZOOM_AMOUNT = 10;
  private message = 'Generating Quick View, please wait';
  private loadingMessage = 'Loading on map, please wait';
  public askQuestion: boolean;
  private getChildrenSubscription: Subscription;
  private selectionEnabled: boolean = false;
  private folderXforms: TransformType[];
  private resultFolder: Folder;
  public loading: boolean = true;
  private toPlacOnCesium: Dataset[];

  __ID = null;
  __EVENTS = null;

  constructor(public dialogRef: MatDialogRef<MapDialogPlotAll>, @Inject(MAT_DIALOG_DATA) public data: any, private fourD: FourDService, 
  public snackBar: MatSnackBar, public dialog: MatDialog, public applicationEvents: XsApplicationEventsService, t: TranslateService, public cesiumMapService: CesiumMapService ) {

    t.get(['DIALOG.GENERATE_VIEW','DIALOG.MAP_LOAD']).subscribe(res => {
      this.message = res[0]
      this.loadingMessage = res[1]
    });

    this.transform = this.data.items;
    this.selectedFolder = this.data.selectedFolder;
    this.photoscanTransformType = this.fourD.transformTypes.filter(tt => tt.isFolder && tt.uid  === '3d-generate')[0];
    this.folderXforms = this.fourD.transformTypes.filter(tt => tt.isSubTransform  && tt.isSubTransform.id === this.photoscanTransformType.id);
  }

  setupMapViewer() {

    let map = this.cesiumMapService.getMap('dialog-all');
    if ( map ) {
      this.viewer = map.viewer;
      this.helper = map.helper;
    }

    this.setupViewerPropertyToDrawRectangle();

    if (this.selectedFolder['lastResultFolder']) {
      this.loading = true;
      this.placeQuickViewOnCesium(this.selectedFolder['lastResultFolder']);
      var searchQ = this.fourD.V.searchByObject(Folder).equals('id',this.selectedFolder['lastResultFolder']);
      searchQ.queryObservable().subscribe(res => {
          this.resultFolder = res.items[0];
        });
    } else {
      this.loading = false;
    }

    this.placeTransformOnMap();
  }

  ngAfterViewInit() {
    this.__ID = XsIdentityInterface.__init(this);
    this.__EVENTS = XsEventListenerInterface.__init(this);
    this.setupMapViewer();
  }


  private addRectangle() {
    this.selector = this.viewer.entities.add({
      selectable: true,
      show: false,
      rectangle: {
        fill: true,
        height: 0,
        outline: true,
        coordinates: this.getSelectorLocations,
        material: Cesium.Color.RED.withAlpha(0.5)
      }
    });
  }

  private setupViewerPropertyToDrawRectangle() {
    this.viewer.scene.screenSpaceCameraController.enableTranslate = false;
    // this.viewer.scene.screenSpaceCameraController.enableTilt = false;
    this.viewer.scene.screenSpaceCameraController.enableLook = false;
    this.viewer.scene.screenSpaceCameraController.enableCollisionDetection = false;
    this.viewer.imageryLayers.get(0).brightness = 0.7;

    this.screenSpaceEventHandler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
    this.camera = this.viewer.camera;
    // this.helper = new FourdCesiumHelper(this.fourD, this.viewer)
    this.helper.registerRenderer(Transform,'public-3d',new Public3DRenderer(this.helper))
  
    this.handler = new Cesium.ScreenSpaceEventHandler(this.viewer.canvas);
    this.scene = this.viewer.scene;

    this.myCallback = this.getSelectorLocation.bind(this);
    this.getSelectorLocations = new Cesium.CallbackProperty(this.myCallback, false);

    this.handleMouseMove();
    this.handleLeftDown();
    this.handleLeftUp();
    //Hide the selector by clicking anywhere
    this.handleLeftDoubleClick();

    this.addRectangle();
  }

  private placeTransformOnMap() {
    this.transform.forEach(
      value => {
        if (value.items.length > 0) {
          this.helper.addPlottable(value.items[0]).subscribe(s => {
            this.helper.sendCameraTo(value.items[0], 800, {vertical_invert: 800})
          })
        }
      }
    );
  }

  private handleLeftDoubleClick() {
    this.screenSpaceEventHandler.setInputAction(() => {
      if (this.selectionEnabled) {
        this.selector.show = false;
        this.enableRotate(true);
        this.selectionEnabled = false;
      }
    }, Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
  }

  private handleLeftUp() {
    this.screenSpaceEventHandler.setInputAction(() => {
      if (this.selectionEnabled) {
        this.mouseDown = false;
        this.firstPointSet = false;
        this.selector.rectangle.coordinates = this.rectangleSelector;
        var pos_ll = new Cesium.Cartesian3.fromRadians(this.rectangleSelector.west, this.rectangleSelector.south, 0);
        var pos_lr = new Cesium.Cartesian3.fromRadians(this.rectangleSelector.east, this.rectangleSelector.south, 0);
        var length = Cesium.Cartesian3.distance(pos_ll, pos_lr);

        var pos_ul = new Cesium.Cartesian3.fromRadians(this.rectangleSelector.west, this.rectangleSelector.north, 0);
        var height = Cesium.Cartesian3.distance(pos_ll, pos_ul);

        var centerX = (this.rectangleSelector.east + this.rectangleSelector.west) / 2 * 180 / Math.PI;
        var centerY = (this.rectangleSelector.north + this.rectangleSelector.south) / 2 * 180 / Math.PI;

        // console.log('centerX' , centerX);
        // console.log('llng', this.toPlacOnCesium[0]['llng']);
        // console.log('ulng', this.toPlacOnCesium[0]['ulng']);
        // console.log('llat', this.toPlacOnCesium[0]['llat']);
        // console.log('llat', this.toPlacOnCesium[0]['ulat']);
        // console.log('centerY', centerY);
        // console.log(this.selector.rectangle.coordinates);

        if(this.toPlacOnCesium.length > 0 && (centerX - this.toPlacOnCesium[0]['llng'] >= 0 ||
           centerX - this.toPlacOnCesium[0]['ulng'] >= 0 ||
           centerY - this.toPlacOnCesium[0]['llat'] >= 0 ||
           centerY - this.toPlacOnCesium[0]['ulat'] >= 0)){
          this.processFullView(length, height, centerX, centerY);
        }else{
          this.snackBar.open('DIALOG.SELECT_VIEW', '',  {duration: Constants.SNACKBAR_DURATION});
        }
      }
    }, Cesium.ScreenSpaceEventType.LEFT_UP);
  }

  private processFullView(length, height, centerX, centerY) {
    if (this.folderXforms.length > 0) {
      let dialogRef = this.dialog.open(APIDialog, {

        // height: '80%',
        data: {
          model: {},
          apis: [this.folderXforms[0]],
          title: 'TYPES.' + this.folderXforms[0].uid,
          askDatasetName: true,
          datasetName: ''
        }
      });

      dialogRef.afterClosed().subscribe(value => {
        if (value) {
          // console.log(value);
          var requestParams = Object.assign({
            width: length,
            height: height,
            center_long: centerX,
            center_lat: centerY,
            batch_id: 'folder_' + this.resultFolder.id
          }, value.model);

          var d = new Dataset(this.fourD.V);
          d.name = value.datasetName;
          d.folder = this.resultFolder;

          // mod by shaz, will download all files and use this name as prefix
          d['map_name'] = value.datasetName

          d.dataType = this.fourD.datasetTypes.find(d => d.id == this.folderXforms[0].createType.id);
          d.saveObservable().subscribe(s =>
              this.startAdHocFullProcess(d, this.resultFolder, requestParams, value.datasetName)
            ,
            e => this.snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION})
          );

        }
      });
    } else {
      console.error('transform type uid 3d-full-proc not found.');
    }
  }

  private handleLeftDown() {
    this.screenSpaceEventHandler.setInputAction(() => {
      if (this.selectionEnabled) {
        this.mouseDown = true;
        this.selector.rectangle.coordinates = this.getSelectorLocations;
      }
    }, Cesium.ScreenSpaceEventType.LEFT_DOWN);
  }

  private handleMouseMove() {
    this.screenSpaceEventHandler.setInputAction((movement) => {
      if (this.selectionEnabled) {
        if (!this.mouseDown) {
          return;
        }

        this.cartesian = this.camera.pickEllipsoid(movement.endPosition, this.viewer.scene.globe.ellipsoid, this.cartesian);

        if (this.cartesian) {
          //mouse cartographic
          this.tempCartographic = Cesium.Cartographic.fromCartesian(this.cartesian, Cesium.Ellipsoid.WGS84, this.tempCartographic);

          if (!this.firstPointSet) {
            Cesium.Cartographic.clone(this.tempCartographic, this.firstPoint);
            this.firstPointSet = true;
          }
          else {
            this.rectangleSelector.east = Math.max(this.tempCartographic.longitude, this.firstPoint.longitude);
            this.rectangleSelector.west = Math.min(this.tempCartographic.longitude, this.firstPoint.longitude);
            this.rectangleSelector.north = Math.max(this.tempCartographic.latitude, this.firstPoint.latitude);
            this.rectangleSelector.south = Math.min(this.tempCartographic.latitude, this.firstPoint.latitude);
          }
          if (this.askQuestion && this.selectionEnabled) {
            this.selector.show = true;
          }
        }
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
  }

  getSelectorLocation(time, result) {
    return Cesium.Rectangle.clone(this.rectangleSelector, result);
  }


  onClick() {
    this.dialogRef.close()
  }

// generate quick view
  quickView() {
    if (this.askQuestion) {
      let dialogRef = this.dialog.open(AppDialog, {
        width: '350px',
        data: {
          title: 'DIALOG.GENERATE_QV_QUESTION',
          text: '',
          posBtn: 'GENERIC.YES',
          negBtn: 'GENERIC.NO',
          input: '',
          error: ''
        }
      });

      dialogRef.afterClosed().subscribe(value => {
        if (!!value) {
          this.processQuickView();
        } else {
          return;
        }
      });
    } else {
      this.processQuickView();
    }
  }

  private processQuickView() {
    this.creatingQuickView = true;
    this.snackBar.open(this.message, '', {duration: Constants.SNACKBAR_DURATION});
    this.resultFolder = new Folder(this.fourD.V).set({
      name: 'Results ' + M(new Date()).format('DD-MM-YY HH:mm')
    })
    this.resultFolder.parent = this.selectedFolder
    this.resultFolder.saveObservable().subscribe(f => {
        var d = new Dataset(this.fourD.V)
        d.name = this.selectedFolder.name + ' ' + this.photoscanTransformType.name;
        d.folder = f;

        d.dataType = this.fourD.datasetTypes.find(d => d.id == this.photoscanTransformType.createType.id);
        d.saveObservable().subscribe(s =>
            this.startAdHoc(d, f)
          ,
          e => this.snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION})
        )
      },
      e => this.snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION})
    )
  }

  private startAdHoc(d: Dataset, resultFolder: Folder) {
    var extraURL = this.photoscanTransformType.id ? ('/' + this.photoscanTransformType.id) : '';
    d.applyTransform(this.photoscanTransformType,{batch_id: 'folder_' + resultFolder.id})
    // this.fourD.V.api('/api/Dataset/' + d.id + '/process/' + this.photoscanTransformType.uid + extraURL, 'post', {batch_id: 'folder_' + resultFolder.id})
      .subscribe(s => {
          this.fourD.onSocketCommand('task_update').subscribe(value => {
            if (value.name === 'TIFF_TILE' && value.status === 'finished' && value.dataset.folder === resultFolder.id) {
              this.selectedFolder.set({'lastResultFolder': resultFolder.id}).saveObservable().subscribe();
              this.placeQuickViewOnCesium(resultFolder.id);
            }
          });
        }
        ,
        e => {
          this.snackBar.open('GENERIC.ERROR ' + e.message, '', {duration: Constants.SNACKBAR_DURATION});
          this.creatingQuickView = false;
        }
      )
  }

  private startAdHocFullProcess(d: Dataset, resultFolder: Folder, requestParams: any, datasetName: string) {
    var extraURL = this.folderXforms[0].id ? ('/' + this.folderXforms[0].id) : '';

    d.applyTransform(this.folderXforms[0],requestParams)
   /* this.fourD.V.api('/api/Dataset/' + d.id + '/process/' + this.folderXforms[0].uid , 'post', requestParams)*/
      .subscribe(s => {
          this.fourD.onSocketCommand('task_update').subscribe(value => {
            // console.log(value);
            if (value.dataset.id === d.id && value.status === 'finished' && value.dataset.folder === resultFolder.id) {
              this.placeQuickViewOnCesium(resultFolder.id, datasetName);
            }
          });
        }
        ,
        e => {
          this.snackBar.open('GENERIC.ERROR ' + e.message, '', {duration: Constants.SNACKBAR_DURATION});
          this.creatingQuickView = false;
        }
      )
  }

  private placeQuickViewOnCesium(resultFolderId: number, datasetName?: string) {
    this.getChildrenSubscription = this.getChildren(resultFolderId).subscribe(value1 => {
        if (value1) {
          if(datasetName){
            this.toPlacOnCesium = value1.filter(value2 => value2.name === datasetName);
          }else{
            this.toPlacOnCesium = value1.filter(value2 => value2.name === 'ortho.tif');
          }

          if (this.toPlacOnCesium.length > 0) {
            this.fourD.V.searchByObject(Transform).equals('input', this.toPlacOnCesium[0]).sortBy('id', true).queryObservable().subscribe(s => {
              this.helper.addPlottable(s.items[0]).subscribe(value2 => {
                this.creatingQuickView = false;
                this.helper.sendCameraTo(s.items[0]);
                this.askQuestion = true;
                this.loading = false;
              });
            })
          }else{
            this.loading = false;
          }
        } else {
          this.askQuestion = false;
        }
      },
      error1 => this.askQuestion = false);
  }

  private setCameraHeight(theMap: any) {
    var camera = this.scene.camera;
    var ellipsoid = this.scene.globe.ellipsoid;
    this.camera_height = ellipsoid.cartesianToCartographic(camera.position).height;
  }

  getChildren(resultFolderId: number): Observable<Dataset[]> {
    var searchQ = this.fourD.V.searchByObject(Dataset).equals('folder', resultFolderId)
    return searchQ.limit(50).sortBy('dateUpdated', true).queryObservable().pipe(
      map(res => {
        return res.items
      })
    )
  }


  ngOnDestroy(): void {
    if (this.getChildrenSubscription) {
      this.getChildrenSubscription.unsubscribe();
    }
    this.handler.destroy();
  }

  selectArea() {
    this.selectionEnabled = true;
    this.enableRotate(false);
  }

  private enableRotate(value: boolean) {
    this.viewer.scene.screenSpaceCameraController.enableRotate = value;
  }
}

